import { render, staticRenderFns } from "./FacetEditor.vue?vue&type=template&id=297a7118&scoped=true"
import script from "./FacetEditor.vue?vue&type=script&lang=js"
export * from "./FacetEditor.vue?vue&type=script&lang=js"
import style0 from "./FacetEditor.vue?vue&type=style&index=0&id=297a7118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a7118",
  null
  
)

export default component.exports